import { render } from "./ServiciosView.vue?vue&type=template&id=609b7088"
import script from "./ServiciosView.vue?vue&type=script&lang=js"
export * from "./ServiciosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__